/** @module                 React */

import { 
    
    useId, 
    
    forwardRef }            from "react";

/** @module                 i18n */

import { useTranslation }   from "react-i18next";

const 

/**
 * 
 * @param { String } type
 * 
 * @param { String } name
 * 
 * @param { String } id
 * 
 * @param { String } value
 * 
 * @param { Function } action
 * 
 * @param { Object } ref
 * 
 * @returns input component
 * 
 */

Input = forwardRef ( ( { type = "text", name, id, value = "", action = false, disabled = false, style = "default", placeholder = "", enterEvent = () => {}, ...props }, ref ) => { const 
    
    generateId = useId ();

    /** @returns */

    return ( <div className={ `input-group ${ style }` }>

        <input 
            
            type={ type } 
            
            id={ ( ! id ) ? generateId : id } 
            
            name={ ( ! name ) ? generateId : name }
            
            value={ value }

            placeholder={ placeholder }

            disabled={ disabled }
            
            onChange={ ( action === false ) ? e => e.target.value : e => action ( e ) }

            onKeyDown={ enterEvent }
            
            ref={ ref }
            
            { ...props } />

    </div> );

} ),

/**
 * 
 * @param { String } type
 * 
 * @param { String } name
 * 
 * @param { String } id
 * 
 * @param { String } value
 * 
 * @param { Function } action
 * 
 * @param { String } label
 * 
 * @param { String } desc
 * 
 * @param { Object } ref
 * 
 * @returns labeled input component
 * 
 */

LabeledInput = forwardRef ( ( { type = "text", name, id, value = "", action = false, label = "Unknown", desc = false, disabled = false, ...props }, ref ) => { const 

    { t } = useTranslation (),
    
    generateId = useId ();

    /** @returns */

    return ( <div className="input-group">

        <label htmlFor={ ( ! id ) ? generateId : id } className="label">

            <div className="name">
                
                { t ( label ) }
                
            </div>

            <Input 

                type={ type } 

                id={ ( ! id ) ? generateId : id } name={ name } 

                value={ value } action={ action }

                disabled={ disabled }
                
                ref={ ref }
                
                { ...props } />

            { desc !== false && <small>

                { t ( desc ) }

            </small> }

        </label>

    </div> );

} );

/** @exports Components */
 
export { 

    LabeledInput,
    
    Input 

}